<template>
  <div class="air_mode_wraper">
    <div
      class="one_mode_wraper"
      @click="modeBtnClickHandle(4)"
      :class=" mode === 4? 'one_mode_wraper_active':''"
    >
      <img
        v-show=" mode === 4 "
        src="../../../assets/img/air-mode-img/kongtiao-zhire-active.png"
        alt
      />
      <img v-show=" mode != 4 " src="../../../assets/img/air-mode-img/kongtiao-zhire.png" alt />
      <div class="mode_text">制热</div>
    </div>
    <div
      class="one_mode_wraper"
      @click="modeBtnClickHandle(1)"
      :class=" mode === 1? 'one_mode_wraper_active':''"
    >
      <img
        v-show=" mode === 1 "
        src="../../../assets/img/air-mode-img/kongtiao-zhileng-active.png"
        alt
      />
      <img v-show=" mode != 1 " src="../../../assets/img/air-mode-img/kongtiao-zhileng.png" alt />
      <div class="mode_text">制冷</div>
    </div>

    <div
      class="one_mode_wraper"
      @click="modeBtnClickHandle(2)"
      :class=" mode === 2? 'one_mode_wraper_active':''"
    >
      <img
        v-show=" mode === 2 "
        src="../../../assets/img/air-mode-img/kongtiao-chushi-active.png"
        alt
      />
      <img v-show=" mode != 2 " src="../../../assets/img/air-mode-img/kongtiao-chushi.png" alt />
      <div class="mode_text">除湿</div>
    </div>
    <div
      class="one_mode_wraper"
      @click="modeBtnClickHandle(3)"
      :class=" mode === 3? 'one_mode_wraper_active':''"
    >
      <img
        v-show=" mode === 3 "
        src="../../../assets/img/air-mode-img/kongtiao-tongfeng-active.png"
        alt
      />
      <img v-show=" mode != 3 " src="../../../assets/img/air-mode-img/kongtiao-tongfeng.png" alt />
      <div class="mode_text">通风</div>
    </div>
    <div
      class="one_mode_wraper"
      @click="modeBtnClickHandle(5)"
      :class=" mode === 5? 'one_mode_wraper_active':''"
    >
      <img
        v-show=" mode === 5 "
        src="../../../assets/img/air-mode-img/kongtiao-zidong-active.png"
        alt
      />
      <img v-show=" mode != 5 " src="../../../assets/img/air-mode-img/kongtiao-zidong.png" alt />
      <div class="mode_text">自动</div>
    </div>
  </div>
</template>

<script>
//1,制冷 2，除湿 3，通风 4，制热 5，自动
export default {
  data() {
    return {
      mode: this.setMode
    };
  },
  props:{
      setMode:{
          type:Number,
          default:3
      }
  },
  methods: {
    modeBtnClickHandle(m) {
      this.mode = m;
      this.$emit("airModeChange",this.mode) ///传给父组件
    }
  },
  watch:{
      setMode(val){
          this.mode = val
          this.$emit("airModeChange",this.mode) ///传给父组件
      }
  }
};
</script>

<style>
.air_mode_wraper {
  width: 100%;
  height: 100px;
  /* border: 1px solid black; */
  color: #f5f5f5;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.one_mode_wraper {
  width: 50px;
  height: 65px;
  border: 1px solid var(--control-outline-color);
  border-radius: 5px;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.one_mode_wraper_active {
  background-color: #f5f5f5;
  color: #282828;
}
.one_mode_wraper:active{
    background:#A0A3A5;
}
.one_mode_wraper img {
  width: 34px;
  height: 34px;
}
.mode_text {
  font-size: 16px;
  /* color: #f5f5f5; */
}
</style>